export default function featuresReducer(state = null, action) {
  switch (action.type) {
    case 'SET_FEATURES':
      return action.payload
    default:
      return state
  }
}
